<div class="tabs" *ngIf="data.tybe === 'icons'">
  <div
    class="tab-label"
    *ngFor="let tab of data.items"
    [class.active]="selectedTab === tab.fileName"
    (click)="selectTab(tab.fileName)"
  >
    <i [class]="tab.imageIconPath"></i>
    <div class="name">{{ tab.lable }}</div>
  </div>
</div>

<div class="category-container">
  <p-carousel
    dir="ltr"
    *ngIf="data.tybe === 'images'"
    [value]="data.items"
    [numVisible]="8"
    [responsiveOptions]="responsiveOptions"
    [numScroll]="1"
    [showIndicators]="false"
  >
    <ng-template pTemplate="item" let-category>
      <div
        class="category-card"
        [ngClass]="{ 'active-category': selectedTab === category.fileName }"
        (click)="selectTab(category.fileName)"
      >
        <img [src]="category.imageIconPath" [alt]="category.lable" />
        <h2>{{ category.lable }}</h2>
      </div>
    </ng-template>
  </p-carousel>
</div>
